import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';

const VRender = lazy(async () => {
  const { VRender } = await import('../sites/vrender');
  return { default: VRender };
});
const VRenderExample = lazy(async () => {
  const { Example } = await import('../sites/vrender/views/example');
  return { default: Example };
});
const VRenderDemo = lazy(async () => {
  const { Demo } = await import('../sites/vrender/views/demo');
  return { default: Demo };
});
const VRenderGuide = lazy(async () => {
  const { Guide } = await import('../sites/vrender/views/guide');
  return { default: Guide };
});
const VRenderOption = lazy(async () => {
  const { Option } = await import('../sites/vrender/views/option');
  return { default: Option };
});
const VRenderContributing = lazy(async () => {
  const { Contributing } = await import('../sites/vrender/views/contributing');
  return { default: Contributing };
});
const VRenderEntry = lazy(async () => {
  const { Entry } = await import('../sites/vrender/views/entry');
  return { default: Entry };
});

export const vrenderRoutes: RouteObject[] = [
  {
    path: '/vrender',
    element: (
      <Suspense>
        <VRender />
      </Suspense>
    ),
  },
  {
    path: '/vrender/example',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VRenderExample />
      </Suspense>
    ),
  },
  {
    path: '/vrender/demo',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VRenderDemo />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VRenderDemo />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vrender/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VRenderGuide />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VRenderGuide />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vrender/option',
    loader: loaders.optionLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VRenderOption />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VRenderOption />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vrender/contributing',
    loader: loaders.contributingLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VRenderContributing />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VRenderContributing />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vrender/entry',
    loader: loaders.entryLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VRenderEntry />
      </Suspense>
    ),
  },
];
